export default "__VITE_ASSET__B6M$qom6__"